// extracted by mini-css-extract-plugin
export default {"page_header":"styles_page_header__3AxQ9","small_page_header":"styles_small_page_header__-Y8bF"};